export const UPDATE_PROCESS_STATEMENT_RTF_FAILURE = 'UPDATE_PROCESS_STATEMENT_RTF_FAILURE';

export const updateProcessStatementRtfFailure = error => ({
    type: UPDATE_PROCESS_STATEMENT_RTF_FAILURE,
    payload: error,
    error: true,
});
